export const FIRST_COLUMN_WIDTH = '300px'
export const FIRST_COLUMN_MOBILE_WIDTH = '150px'
export const VERY_LONG_COLUMN_WIDTH = '200px'
export const LONG_COLUMN_WIDTH = '150px'
export const VALUE_COLUMN_WIDTH = '140px'
export const SHORT_COLUMN_WIDTH = '100px'
